module.exports = __webpack_public_path__ + "img/pt-15.9293fe67.jpg";